import React from 'react';
import {Route} from 'react-router';

import ContentDiscoveryDocumentWithRequiredSession from './Document/AssignmentDocument';

import {ContentDiscoveryProvider} from './ContentDiscoveryProvider.react';

export const ContentDiscoveryDocumentWithContext = ({route}: any) => {
  return (
    <ContentDiscoveryProvider>
      <ContentDiscoveryDocumentWithRequiredSession route={route} />
    </ContentDiscoveryProvider>
  );
};

const ContentDiscoveryRoutes = (
  <>
    <Route
      path='assignment-builder/create-assignment'
      component={ContentDiscoveryDocumentWithContext}
    />
  </>
);

export default ContentDiscoveryRoutes;
